define(function(require) {

	const CN = require('civicsUtils/constants');
	const Utils = require('civicsUtils/general_utilities');

	return {
		// Common Template Helper Code
		commonHelpers: function(view) {
			var helpers = {
				displayScheduledDate: function() {
					//
					// Value to show as the Scheduled Date is one of:
					// - the actual Scheduled Date
					// - TBD
					// - Pending
					//
					if (this.isInspectionClosed || this.isInspectionScheduled) {
						return Handlebars.helpers['global:formatDate'](view.model.get('scheduledDateTime'));
					}
					// Date Not Requested
					if (this.isInspectionDateNotRequested) {
						return i18n.t('CIVICS.INSPECTION_REQUEST.TBD');
					}
					// Date Pending
					if (this.isInspectionDatePending) {
						return i18n.t('CIVICS.INSPECTION_REQUEST.PENDING');
					}
					return i18n.t('CIVICS.INSPECTION_REQUEST.ERROR');
				},
				getInspectionDateState: function() {
					//
					// Inspection Date State is one of 4 (or 3) values:
					// - Closed
					// - Scheduled
					// - Date Pending   (if config.captureRequestDateToCallDate is true)
					// - Date Not Requested
					// - Closed if the parent instrument is closed
					var scheduledDateTime = view.model.get('scheduledDateTime');
					var result = view.model.get('result');

					// if (__DEV__) console.log('common view - inspection_request - getInspectionDateState schedDT: ', scheduledDateTime, ' result: ', result);
					if (typeof result != 'undefined' && result.trim().length > 0) {
						// Has a result
						return view.config.INSPECTION_STATE.CLOSED;
					}
					if( view.applicationModel && view.applicationModel.get('PortalStatus') == "Closed" ){
						//parent instrument is in a closed state
						return view.config.INSPECTION_STATE.CLOSED;
					}
					if (typeof scheduledDateTime != 'undefined' && Utils.dateExists(scheduledDateTime)) {
						// No result but has a Scheduled Date
						return view.config.INSPECTION_STATE.SCHEDULED;
					}
					if (view.config.captureRequestDateToCallDate) {
						var callDateTime = view.model.get('callDateTime');
						if (typeof callDateTime != 'undefined' && Utils.dateExists(callDateTime)) {
							// No result, no Scheduled Date, but has a Call Date
							return view.config.INSPECTION_STATE.DATE_PENDING;
						}
					}
					// None of the above
					return view.config.INSPECTION_STATE.DATE_NOT_REQUESTED;
				},
				isPartialInspection: function() {
					let isPartial = view.model.get('isPartial');

					if (typeof isPartial === 'boolean') {
						return isPartial;
					}

					return view.model.get('isPartial') && view.model.get('isPartial').toLowerCase() == "true" ? true : false;
				},
				isInspectionRecordingPartiallyComplete: function() {

					var hours = view.model.get('inspectionHours');
					// if(__DEV__) console.log('common view - inspection_request - isRecordingPartiallyComplete ',
					// 			' resultDateTime: ', view.model.get('resultDateTime'),
					// 			' startDateTime: ', view.model.get('startDateTime'),
					// 			' completedDateTime: ', view.model.get('completedDateTime'),
					// 			' hours: ', hours);
					if (!Utils.dateExists(view.model.get('resultDateTime'))){
						if (Utils.dateExists(view.model.get('startDateTime')) ||
							Utils.dateExists(view.model.get('completedDateTime')) ||
							hours > 0) {
							// recording is partially complete
							return true;
						}
					}
					return false;
				},
				selectExistingAssignedToProvider: function(id) {
					if (id == view.model.get('assignedToProvider.id')) {
						return 'selected';
					}
					return '';
				},
				selectDroppyExistingAssignedToProvider: function(id) {
					if (id == view.model.get('assignedToProvider.id')) {
						return true;
					}
					return false;
				},
				selectExistingTimePreference: function(code) { //old function/helper from time preference dropdown.
					if (code == view.model.get('timePreference')) {
						return 'selected';
					}
					return '';
				},
				selectDroppyExistingTimePreference: function(code) {
					if (code == view.model.get('timePreference')) {
						return true;
					}
					return false;
				},
			};
			//
			// Extending the helpers for properties that need to call other helper functions
			//
			_.extend(helpers, {
				isInspectionScheduled: helpers.getInspectionDateState() == view.config.INSPECTION_STATE.SCHEDULED,
				isInspectionClosed: helpers.getInspectionDateState() == view.config.INSPECTION_STATE.CLOSED,
				isInspectionDateNotRequested: helpers.getInspectionDateState() == view.config.INSPECTION_STATE.DATE_NOT_REQUESTED,
				isInspectionDatePending: helpers.getInspectionDateState() == view.config.INSPECTION_STATE.DATE_PENDING,
				isInspectionOpen: helpers.getInspectionDateState() != view.config.INSPECTION_STATE.CLOSED,
			},{
				displayInspectionAssignmentScheduledDate: function() {
					var inspectionAssignmentScheduledDate = this.getInspectionAssignmentScheduledDate();
					if (inspectionAssignmentScheduledDate.length > 0) {
						return Handlebars.helpers['global:formatDate'](inspectionAssignmentScheduledDate);
					}
					// fall thru
					return i18n.t('CIVICS.INSPECTION_REQUEST.TBD');
				},
				getInspectionAssignmentScheduledDate: function() {
					//
					// Return one of ...
					// - Scheduled Date
					// - Call Date (aka Request Date)
					// - ''
					//
					if (this.isInspectionScheduled) {
						return view.model.get('scheduledDateTime');
					}
					if (this.isInspectionDatePending) {
						return view.model.get('callDateTime');
					}
					// fall thru
					return '';
				},
			});
			return helpers;
		}
	}
});
